import clsx from 'clsx';

import { X } from '../../../../icons';
import { textMd } from '../../../../typography';

import * as styles from './TooltipContent.module.css';

import type React from 'react';
import type { RefObject } from 'react';

type Props = {
  content: React.ReactNode;
  className?: string;
  dialogRef?: RefObject<HTMLDivElement>;
  onClose: () => void;
};

export const TooltipContent = ({ content, dialogRef, onClose, className = '' }: Props): JSX.Element => {
  return (
    <div ref={dialogRef} className={clsx(styles.wrapper, className)}>
      <div className={clsx(styles.content, textMd)}>{content}</div>
      {/* onMouseDown and onTouchStart is used here because onClick doesn't work if the tooltip is placed
      inside a portal (like a modal). */}
      <button className={styles.button} onMouseDown={onClose} onTouchStart={onClose} data-testid='tooltip-close'>
        <X className={styles.closeIcon} />
      </button>
    </div>
  );
};
